<template>
  <div class="course_and_broadcast_container">
    <CardTitle :title="data.title" :skipPage="'/broadcastAndCourse?moduleId=' + data.id" />

    <div class="list" :class="{ full: isBigList }" v-if="isBigList || isGridList">
      <template v-for="item in listData" :key="item.id">
        <div class="list_item" @click="skipCourseHandle(item)" v-if="item.fileId">
          <div class="item_img_wrapper">
            <img class="item_img" :src="item.coverImgUrl" />
            <div class="item_img_tag" v-if="item.learnStatus === 1">
              <span class="tag_text">{{ $t('app_learned_short') }}</span>
            </div>
            <div class="item_img_type">
              <span class="type_text">{{ getFileTypeName(item.fileType) }}</span>
            </div>
          </div>
          <p class="item_text">{{ item.fileName }}</p>
          <p class="item_detail">
            <span class="detail_score">{{ item.score || 0 }}{{ $t('app_score') }}</span>
            <span class="detail_count"> | {{ item.learnNum }}{{ $t('app_people_learned') }}</span>
          </p>
        </div>
        <div class="list_item" @click="skipBroadcastHandle(item)" v-else>
          <div class="item_img_wrapper">
            <img class="item_img" :src="item.coverImgUrl" />
          </div>
          <p class="item_text">{{ item.title }}</p>
          <p class="item_text2">{{ item.author }}</p>
          <p class="item_label">
            <span class="detail_time">{{ item.releaseTime }}</span>
            <span class="detail_num">
              <i class="iconfont icon-icon_shouye_guankanrenshu" />
              {{ item.viewCount }}
            </span>
          </p>
        </div>
      </template>
    </div>

    <div class="list1" v-if="isSmallList">
      <template v-for="item in listData" :key="item.id">
        <div class="list_item" @click="skipCourseHandle(item)" v-if="item.fileId">
          <div class="item_img_wrapper">
            <img class="item_img" :src="item.coverImgUrl" />
            <div class="item_img_tag" v-if="item.learnStatus === 1">
              <span class="tag_text">{{ $t('app_learned_short') }}</span>
            </div>
            <div class="item_img_type">
              <span class="type_text">{{ getFileTypeName(item.fileType) }}</span>
            </div>
          </div>
          <div class="item_text_wrapper">
            <p class="item_text">{{ item.fileName }}</p>
            <div class="item_detail item_detail1">
              <span class="detail_score">{{ item.score || 0 }}{{ $t('app_score') }}</span>
            </div>
            <div class="item_detail item_detail1">
              <span class="detail_count">{{ item.learnNum }}{{ $t('app_people_learned') }}</span>
            </div>
          </div>
        </div>
        <div class="list_item" @click="skipBroadcastHandle(item)" v-else>
          <div class="item_img_wrapper">
            <img class="item_img" :src="item.coverImgUrl" />
          </div>
          <div class="item_text_wrapper">
            <p class="item_text">{{ item.title }}</p>
            <p class="item_author">{{ item.author }}</p>
            <div class="item_label">
              <span class="detail_time">{{ item.releaseTime }}</span>

              <span class="detail_num">
                <i class="iconfont icon-icon_shouye_guankanrenshu" />
                {{ item.viewCount }}
              </span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import CardTitle from './CardTitle.vue'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useThemeColor } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { addViewCountReq, addUvCountReq } from '@/api/requests/BroadRequests'

const props = defineProps<{
  data: LmsDecorateModule
}>()

const router = useRouter()
interface TItem {
  fileId: string
  fileType: number
}
const skipCourseHandle = (item: TItem) => {
  router.push({
    name: 'courseDetail',
    query: {
      id: item.fileId,
      courseId: '',
      endingType: 0,
      channel: 0,
      courseType: item.fileType > 0 ? 'courseWare' : 'course'
    }
  })
}
interface TItem1 {
  id: string
  articleType: number
  jumpUrl: string
}
const skipBroadcastHandle = async (item: TItem1) => {
  addUvCountReq({
    id: item.id
  })
  if (item.articleType === 1 && item.jumpUrl && item.jumpUrl.length > 0) {
    try {
      const res = await addViewCountReq({ id: item.id })
      if (res?.code === 1) {
        window.location.href = item.jumpUrl
      }
    } catch (error) {
      console.error('Error adding view count:', error)
    }
  } else {
    router.push('/broadcastDetail/' + item.id)
  }
}

const broadcastData = computed(() => {
  const datas = props.data.lmsDecorateModuleCategories[0].datas
  if (!datas) {
    return []
  }
  let json = ''
  for (let i = 0; i < datas.length; i++) {
    const item = datas[i]
    if (item.type === 4) {
      json = item.json
    }
  }
  try {
    // console.log(JSON.parse(json))
    return JSON.parse(json)
  } catch (error) {
    return []
  }
})
const courseData = computed(() => {
  const datas = props.data.lmsDecorateModuleCategories[0].datas
  if (!datas) {
    return []
  }
  let json = ''
  for (let i = 0; i < datas.length; i++) {
    const item = datas[i]
    if (item.type === 3) {
      json = item.json
    }
  }
  try {
    // console.log(JSON.parse(json))
    return JSON.parse(json)
  } catch (error) {
    return []
  }
})
const listData = computed(() => {
  const arr = [...courseData.value, ...broadcastData.value].sort((a, b) => {
    return a.sort - b.sort
  })
  return arr
})

const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).layoutType
  } catch (error) {
    return 3
  }
})
const isSmallList = computed(() => type.value === 1)
const isBigList = computed(() => type.value === 2)
const isGridList = computed(() => type.value === 3)

const { t } = useI18n()
const getFileTypeName = (type: number) => {
  // 类型 0:课程,1:文档,2:视频,3:图片
  switch (type) {
    case 0:
      return t('app_course')
    case 1:
      return t('tag_doc')
    case 2:
      return t('tag_video')
    case 3:
      return t('tag_pic')
  }
}

const themeColor = useThemeColor()
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');
@imgWidth: calc((100vw - 32px - 24px - 10px) / 2);
@imgHeight: calc((100vw - 32px - 24px - 10px) / 2 * 0.58);
@imgHeight2: calc((100vw - 32px - 24px) * 0.58);
@imgHeight3: calc((100vw - 220px) / 2 * 0.58);

.course_and_broadcast_container {
  margin: 12px 16px;
  padding: 0 12px;
  background-color: @contentBackground;
  border-radius: 8px;

  .list {
    padding-bottom: 16px;
    display: flex;
    flex-wrap: wrap;
    &.full {
      .list_item {
        width: 100%;
        margin-left: 0 !important;
        .item_img {
          width: 100%;
          height: @imgHeight2;
          border-radius: 5px;
        }
      }
    }
    .list_item {
      width: @imgWidth;
      margin-top: 10px;
      &:nth-child(even) {
        margin-left: 10px;
      }
      .item_img_wrapper {
        position: relative;
      }
      .item_img {
        width: 100%;
        height: @imgHeight;
        border-radius: 5px;
      }
      .item_img_tag {
        // width: 30px;
        height: 16px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: v-bind(themeColor);
        .flex_center;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        .tag_text {
          font-size: 12px;
          transform: scale(0.75);
          color: @textWhite;
        }
      }
      .item_img_type {
        position: absolute;
        bottom: 4px;
        right: 4px;
        border-radius: 3px;
        padding: 1px 2px;
        background-color: rgba(0, 0, 0, 0.4);
        .flex_center;
        .type_text {
          color: @textWhite;
          transform: scale(0.833);
          font-size: 12px;
        }
      }
      .item_text {
        width: 100%;
        margin-top: 8px;
        font-size: 14px;
        color: @textPrimary;
        .text_etc;
      }
      .item_text2 {
        margin-top: 3px;
        color: @textSecondary99;
        font-size: 12px;
      }
      .item_detail {
        margin-top: 4px;
        font-size: 12px;
        .detail_score {
          color: v-bind(themeColor);
        }
        .detail_count {
          color: @textSecondary99;
        }
      }
      .item_label {
        margin-top: 4px;
        display: flex;
        justify-content: space-between;
        .detail_time {
          color: @textSecondary99;
          font-size: 12px;
        }
        .detail_num {
          font-size: 12px;
          color: @textNormal;
          .iconfont {
            font-size: 12px;
            color: @textSecondary99;
          }
        }
      }
    }
  }

  .list1 {
    .list_item {
      padding: 14px 0;
      display: flex;
      .border_1px_b;
      .item_img_wrapper {
        flex: 0 0 auto;
        width: 96px;
        height: 56px;
        position: relative;
      }
      .item_img {
        width: 100%;
        border-radius: 5px;
        height: @imgHeight3;
      }
      .item_img_tag {
        // width: 30px;
        height: 16px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: v-bind(themeColor);
        .flex_center;
        border-top-left-radius: 5px;
        border-bottom-right-radius: 5px;
        .tag_text {
          font-size: 12px;
          transform: scale(0.75);
          color: @textWhite;
        }
      }
      .item_img_type {
        position: absolute;
        bottom: 4px;
        right: 4px;
        border-radius: 3px;
        padding: 1px 2px;
        background-color: rgba(0, 0, 0, 0.4);
        .flex_center;
        .type_text {
          color: @textWhite;
          transform: scale(0.833);
          font-size: 12px;
        }
      }

      .item_text_wrapper {
        width: 0;
        flex: 1;
        margin-left: 10px;
      }
      .item_text {
        width: 100%;
        font-size: 14px;
        color: @textPrimary;
        .text_etc;
      }
      .item_author {
        margin-top: 6px;
        font-size: 12px;
        color: @textSecondary99;
        .text_etc;
      }
      .item_detail {
        margin-top: 6px;
        font-size: 12px;
        .detail_score {
          color: v-bind(themeColor);
        }
        .detail_count {
          color: @textSecondary99;
        }
        &.item_detail1 {
          margin-top: 0;
        }
      }
      .item_label {
        margin-top: 4px;
        display: flex;
        justify-content: space-between;
        .detail_time {
          color: @textSecondary99;
          font-size: 12px;
        }
        .detail_num {
          font-size: 12px;
          color: @textNormal;
          .iconfont {
            font-size: 12px;
            color: @textSecondary99;
          }
        }
      }
    }
  }
}
</style>
